<av-content-container>
  <div class="col-6 mb-4 d-flex align-items-stretch">
    <av-table-card [titleKey]="'app.device.security.sections.microsoft_patches.title'" icon="update"
      [columns]="patchColumns" [rows]="patchRows()"
      [countLabelKey]="'app.device.security.count.patches_found_suffix'"
      [emptyTextKey]="'app.device.security.empty.patches'" [pageSize]="5" />
  </div>

  <div class="col-6 mb-4">
    <av-card cardTitle="app.device.security.sections.microsoft_defender.title" icon="shield"
      [fields]="defenderFields()" [dialog]="defenderDialog()" />
  </div>

  <div class="col-6 d-flex align-items-stretch">
    <av-table-card [titleKey]="'app.device.security.sections.certificates.title'" icon="verified_user"
      [columns]="certificateColumns" [rows]="certificateRows()"
      [countLabelKey]="'app.device.security.count.certificates_found_suffix'"
      [emptyTextKey]="'app.device.security.empty.certificates'" [pageSize]="5" [trackByKey]="'thumbprint'" />
  </div>

  <div class="col-6 d-flex align-items-stretch">
    <av-table-card [titleKey]="'app.device.security.sections.disk_encryption.title'" icon="lock"
      [columns]="diskEncryptionColumns" [rows]="diskEncryptionRows()"
      [countLabelKey]="'app.device.security.count.disk_encryption_found_suffix'"
      [emptyTextKey]="'app.device.security.empty.disk_encryption'" [pageSize]="5" />
  </div>
</av-content-container>